import React, { useState, useContext, useEffect } from 'react';
import UserContext from '../../context/Globales/UserContext';
import {
    Typography,
    makeStyles,
    TableContainer, Table, TableCell, TableRow, TableHead, TableBody, Button, Grid, Modal, Backdrop, Fade
} from '@material-ui/core';
import { v4 as uuid } from 'uuid';

import IcpdfDireccionesModal from '../pdf/IC/IcpdfDireccionesModal';



const formatterPeso = new Intl.NumberFormat('es-CL', {
    style: 'currency',
    currency: 'CLP'
})



const useStyles = makeStyles((theme) => ({
    tituloTable: {

        backgroundColor: '#e6e6e6',
        minWidth: 200,
        color: 'black',
        textAlign: 'center',
        padding: '10px',
        fontWeight: '250',
        fontSize: '16px'
    },
    TituloIdentificacion: {

        backgroundColor: theme.palette.primary.main,
        minWidth: 200,
        color: 'white',
        textAlign: 'center',
        padding: '15px',
        fontWeight: '250',
        fontSize: '18px',
        height: 'auto',
        alignContent: 'center',
    },
    FondoTable: {

        backgroundColor: theme.palette.greyFondo.main
    },
    containerTable: {
        maxHeight: 440,
        maxWidth: '100%'
    },

    modalPdf: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
    },
    paperPdf: {
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        width: '50%',
    },
}));

const TblDireccionesModal = () => {
    const classes = useStyles();

    const { DatodetalleDireccionesModal } = useContext(UserContext);


    const [OpenModalPdf, setOpenModalPdf] = React.useState(false)


    const handlClickPdf = () => {

        setOpenModalPdf(!OpenModalPdf)

    }
    const handlClickClose = () => {
        setOpenModalPdf(false)
    }



    return (
        <div>

            {/*MODAL PDF INFORME COMER*/}

            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classes.modalPdf}
                open={OpenModalPdf}
                onClose={handlClickClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 2000,
                }}>
                <Fade in={OpenModalPdf}>

                    <div className={classes.paperPdf}>


                        <IcpdfDireccionesModal />



                    </div>

                </Fade>
            </Modal>






            <h6 className={classes.tituloTable}>Detalle Direcciones</h6>

            <h5>{ DatodetalleDireccionesModal &&  DatodetalleDireccionesModal.Detalles == 'ERROR CONSULTA DIRECCIONES' ?
                'Error al procesar su solicitud, inténtelo mas tarde (INFORME COMERCIAL)' : ''}</h5>


            { DatodetalleDireccionesModal && DatodetalleDireccionesModal.Detalles == null ? <h2>Cargando información...</h2>
                : <div style={{ alignContent: "center", textAlign: "center" }}><Button variant="contained" color="primary" onClick={handlClickPdf}>Descargar PDF</Button></div>}

            <br />

            <Grid container direction="row" justify="space-between" alignItems="flex-start">
                <Grid item xs={6} sm={6} xl={6} md={6} lg={6}>
                    <TableContainer >

                        <Table>

                            <TableHead className={classes.FondoTable}>

                                <TableRow >
                                    <TableCell>Total direcciones registrada: { DatodetalleDireccionesModal && DatodetalleDireccionesModal.Resumen?.NumeroDirecciones} </TableCell>

                                </TableRow>

                            </TableHead>

                        </Table>
                    </TableContainer>
                </Grid>



            </Grid>

            <TableContainer className={classes.containerTable}>
                <Table size="small">
                    <TableHead className={classes.FondoTable}>

                        <TableRow>
                            <TableCell>#</TableCell>
                            <TableCell>Dirección.</TableCell>
                            <TableCell>Comuna</TableCell>
                            <TableCell>Ciudad</TableCell>
                            <TableCell>Tipo</TableCell>
                            <TableCell>Fecha Registro</TableCell>
                            <TableCell></TableCell>
                        </TableRow>

                    </TableHead>
                    <TableBody>
                         { DatodetalleDireccionesModal &&  DatodetalleDireccionesModal.Detalles?.map((detalleDire, id) => (

                            <TableRow key={uuid()}>
                                <TableCell>{id + 1}</TableCell>
                                <TableCell>{detalleDire.Direccion}</TableCell>
                                <TableCell>{detalleDire.Comuna}</TableCell>
                                <TableCell>{detalleDire.Ciudad}</TableCell>
                                <TableCell>{detalleDire.Tipo}</TableCell>
                                <TableCell>{detalleDire.Fecha}</TableCell>
                            </TableRow>
                        ))}
                    </TableBody>

                </Table>

            </TableContainer>


        </div>
    )
}

export default TblDireccionesModal;
